const mjmlTemplate = `<mjml>
  <mj-head>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif" color="#3b4c56" />
      <mj-text font-size="15px" line-height="1.6" padding="0" />
      <mj-section padding="0" />
      <mj-column padding="0" />
    </mj-attributes>
    <mj-preview>
      {{preheaderText}}
    </mj-preview>
    <mj-style inline="inline">
      .markdown p + p { margin-top: 10px; }
      .markdown ul, .markdown ol { margin: 10px 0; padding-left: 20px; }
      .markdown li + li { margin-top: 6px; }
      .markdown a { color: inherit; text-decoration: underline; }
      .markdown strong { font-weight: 600; }
      .markdown em { font-style: italic; }
      .legal a { color: inherit !important; text-decoration: underline; }
      .legal-links a { cursor: pointer; }
      .social-icon {
        width: 18px !important; height: 18px !important; display: inline-block;
      }
      .display-title-serif div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 18px !important;
        line-height: 1.3 !important;
        font-weight: 400 !important;
        letter-spacing: 0.04em !important;
        text-transform: uppercase !important;
        color: #111827 !important;
        text-align: center !important;
      }
      .showcase-body div,
      .showcase-body p {
        font-size: 12px !important;
        line-height: 1.55 !important;
        text-align: left !important;
      }
      .feature-block div,
      .feature-block p {
        font-size: 12px !important;
        line-height: 1.5 !important;
        text-align: center !important;
      }
      .feature-block h2,
      .feature-block h3 {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 16px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        text-transform: uppercase !important;
        color: #111827 !important;
        margin: 0 0 8px 0 !important;
      }
      .section-kicker div {
        font-size: 10px !important;
        letter-spacing: 0.14em !important;
        text-transform: uppercase !important;
        color: #888888 !important;
        font-weight: 600 !important;
        text-align: center !important;
      }
      .text-link-arrow a {
        display: block !important;
        color: #ffffff !important;
        background-color: {{ctaBackgroundColor}} !important;
        font-size: 10px !important;
        font-weight: 600 !important;
        letter-spacing: 0.12em !important;
        text-transform: uppercase !important;
        text-decoration: none !important;
        padding: 10px 12px !important;
      }
      .destination-heading div {
        font-size: 12px !important;
        letter-spacing: 0.18em !important;
        text-transform: uppercase !important;
        font-weight: 600 !important;
        color: #ffffff !important;
        text-align: center !important;
      }
      .destination-link a {
        display: inline-block !important;
        color: #d8d8d8 !important;
        font-size: 10px !important;
        text-decoration: underline !important;
        padding: 4px 5px !important;
      }
      .showcase-hero-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .showcase-story-image img {
        display: block !important;
        width: 100% !important;
        max-width: 250px !important;
        height: auto !important;
        margin: 0 auto !important;
      }
      .showcase-header-social td {
        text-align: right !important;
      }
      .showcase-footer-contact div,
      .showcase-footer-contact p,
      .showcase-footer-contact a {
        color: #ffffff !important;
        font-size: 11px !important;
        line-height: 1.5 !important;
      }
      .showcase-footer-social td {
        text-align: right !important;
      }
      .showcase-legal div,
      .showcase-legal p,
      .showcase-legal a {
        color: #666666 !important;
        font-size: 10px !important;
        line-height: 1.55 !important;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#EEF1F7" width="600px">
    <mj-wrapper padding="0">
      <mj-section background-color="{{headerBgColor}}" padding="4px 18px" css-class="mjml-header">
        <mj-column>
          <mj-table css-class="showcase-header-social" align="right" padding="0">
            <tr>
              <td style="text-align:right;white-space:nowrap;">
                <!-- socialMediaLinksHtml -->
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
      <mj-section background-color="{{headerBgColor}}" padding="12px 30px" css-class="mjml-header">
        <mj-column>
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0" width="{{logoWidth}}" height="{{logoHeight}}" css-class="mjml-logo" />
        </mj-column>
      </mj-section>

      <mj-section padding="8px" css-class="mjml-hero" background-color="#FFFFFF">
        <mj-column>
          <mj-image src="{{heroImgUrl}}" alt="Hero" padding="0" href="{{heroImageLinkUrl}}" fluid-on-mobile="true" css-class="showcase-hero-image" />
        </mj-column>
      </mj-section>

      <mj-section padding="30px 32px 18px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="display-title-serif" align="center" padding="0 0 18px 0">
            {{emailTitle}}
          </mj-text>
          <mj-text css-class="markdown showcase-body" align="left" padding="0" line-height="1.55" font-size="12px">
            <!-- bodyHtml -->
          </mj-text>
          <mj-text css-class="mjml-cta text-link-arrow" align="center" padding="18px 0 0 0">
            <a href="{{ctaUrl}}">{{ctaText}}</a>
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section padding="16px 12px 26px" background-color="#FFFFFF">
        <mj-column width="50%" padding="0 6px" css-class="mjml-col1">
          <mj-image src="{{col1Image}}" alt="Feature" padding="0 0 16px 0" href="{{col1ImageLinkUrl}}" css-class="showcase-story-image" />
          <mj-text css-class="markdown feature-block" align="center" padding="0 0 12px 0" line-height="1.65" font-size="15px">
            <!-- col1Html -->
          </mj-text>
          <mj-text css-class="text-link-arrow" align="center" padding="0 0 28px 0">
            <a href="{{col1LinkUrl}}">{{col1LinkText}}</a>
          </mj-text>
        </mj-column>
        <mj-column width="50%" padding="0 6px" css-class="mjml-col2">
          <mj-image src="{{col2Image}}" alt="Feature" padding="0 0 16px 0" href="{{col2ImageLinkUrl}}" css-class="showcase-story-image" />
          <mj-text css-class="markdown feature-block" align="center" padding="0 0 12px 0" line-height="1.65" font-size="15px">
            <!-- col2Html -->
          </mj-text>
          <mj-text css-class="text-link-arrow" align="center" padding="0 0 28px 0">
            <a href="{{col2LinkUrl}}">{{col2LinkText}}</a>
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section padding="22px 30px 8px" css-class="mjml-discoverIntro" background-color="#000000">
        <mj-column>
          <mj-text css-class="destination-heading" align="center" padding="0 0 12px 0">{{galleryTitle}}</mj-text>
        </mj-column>
      </mj-section>

      <mj-section padding="0 20px 22px" css-class="mjml-discoverButtons" background-color="#000000">
        <mj-column>
          <mj-text css-class="destination-link" align="center" padding="0">
            <a href="{{discoverBtn1LinkUrl}}">{{discoverBtn1}}</a>
            <span style="color:#9ca3af;">|</span>
            <a href="{{discoverBtn2LinkUrl}}">{{discoverBtn2}}</a>
            <span style="color:#9ca3af;">|</span>
            <a href="{{discoverBtn3LinkUrl}}">{{discoverBtn3}}</a>
            <span style="color:#9ca3af;">|</span>
            <a href="{{discoverBtn4LinkUrl}}">{{discoverBtn4}}</a>
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section padding="14px 24px 22px" css-class="mjml-footer" background-color="#000000">
        <mj-column width="62%" vertical-align="middle">
          <mj-text css-class="showcase-footer-contact" align="left" padding="0">
            <p style="margin:0 0 6px 0;font-weight:600;">{{hotelName}}</p>
            <p style="margin:0 0 6px 0;">{{hotelAddress}}<br/>{{hotelCityStateZip}}</p>
            <p style="margin:0 0 4px 0;"><a href="tel:{{hotelPhone}}" style="color:#ffffff;text-decoration:underline;">{{hotelPhone}}</a></p>
            <p style="margin:0;"><a href="{{hotelWebsiteUrl}}" style="color:#ffffff;text-decoration:underline;">{{hotelWebsite}}</a></p>
          </mj-text>
        </mj-column>
        <mj-column width="38%" vertical-align="middle">
          <mj-table css-class="showcase-footer-social" align="right" padding="0">
            <tr>
              <td style="text-align:right;white-space:nowrap;">
                <!-- socialMediaLinksHtml -->
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
      <mj-section padding="16px 24px 24px" css-class="mjml-footer" background-color="#F0F0F0">
        <mj-column>
          <mj-text css-class="markdown showcase-legal" align="left" padding="0 0 12px 0">
            <!-- finePrintHtml -->
          </mj-text>
          <mj-text align="center" font-size="10px" css-class="legal showcase-legal" padding="0" color="#666666">
            <div class="legal-links" style="opacity:.5;">
              <a style="text-decoration: none;" href="{{privacyPolicyUrl}}">Privacy</a>
              <span style="display:inline-block;width:10px;font-size:9px;">|</span>
              <a style="text-decoration: none;" href="{{termsUrl}}">Terms</a>
              <span style="display:inline-block;width:10px;font-size:9px;">|</span>
              <a style="text-decoration: none;" href="{{unsubscribeUrl}}">Unsubscribe</a>
            </div>
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`

export default mjmlTemplate
